var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqAccountGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_889_76339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 6.30005C11.5558 6.30005 6.2998 11.556 6.2998 18C6.2998 20.772 7.2718 23.31 8.8738 25.308C11.4838 23.544 14.6158 22.5 17.9998 22.5C21.3838 22.5 24.5158 23.544 27.1258 25.308C28.7458 23.31 29.6998 20.754 29.6998 18C29.6998 11.556 24.4438 6.30005 17.9998 6.30005ZM17.9998 20.7C15.0118 20.7 12.5998 18.288 12.5998 15.3C12.5998 12.312 15.0118 9.90005 17.9998 9.90005C20.9878 9.90005 23.3998 12.312 23.3998 15.3C23.3998 18.288 20.9878 20.7 17.9998 20.7Z",
    fill: "#F9FCEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9996 9.90015C15.0116 9.90015 12.5996 12.3121 12.5996 15.3001C12.5996 18.2881 15.0116 20.7001 17.9996 20.7001C20.9876 20.7001 23.3996 18.2881 23.3996 15.3001C23.3996 12.3121 20.9876 9.90015 17.9996 9.90015ZM17.9996 18.0001C16.5056 18.0001 15.2996 16.7941 15.2996 15.3001C15.2996 13.8061 16.5056 12.6001 17.9996 12.6001C19.4936 12.6001 20.6996 13.8061 20.6996 15.3001C20.6996 16.7941 19.4936 18.0001 17.9996 18.0001Z",
    fill: "#A9CF3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9996 3.6001C10.0436 3.6001 3.59961 10.0441 3.59961 18.0001C3.59961 25.9561 10.0436 32.4001 17.9996 32.4001C25.9556 32.4001 32.3996 25.9561 32.3996 18.0001C32.3996 10.0441 25.9556 3.6001 17.9996 3.6001ZM17.9996 29.7001C15.3176 29.7001 12.8516 28.7821 10.8716 27.2521C12.9416 25.9561 15.3896 25.2001 17.9996 25.2001C20.6096 25.2001 23.0576 25.9561 25.1276 27.2521C23.1476 28.7821 20.6816 29.7001 17.9996 29.7001ZM27.1256 25.3081C24.5336 23.5261 21.3836 22.5001 17.9996 22.5001C14.6156 22.5001 11.4836 23.5441 8.87361 25.3081C7.27161 23.3101 6.29961 20.7721 6.29961 18.0001C6.29961 11.5561 11.5556 6.3001 17.9996 6.3001C24.4436 6.3001 29.6996 11.5561 29.6996 18.0001C29.6996 20.7721 28.7276 23.3101 27.1256 25.3081Z",
    fill: "#A9CF3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_889_76339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqAccountGreen);
export default __webpack_public_path__ + "static/media/faq-account-green.05bd7b7cf6997f69f5fd9a369ab0575a.svg";
export { ForwardRef as ReactComponent };